module.exports = __webpack_public_path__ + "img/2.6_About-Us_Key-Partner_8_Central-Queensland_Uni.addcd5d717e069e9ce9d7e1f8f633a35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_About-Us_Key-Partner_8_Central-Queensland_Uni.png
// module id = 785
// module chunks = 0